<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.34375 13.2812V12.5C2.34375 11.2056 3.39308 10.1562 4.6875 10.1562H20.3125C21.6069 10.1562 22.6562 11.2056 22.6562 12.5V13.2812M13.6049 6.5736L11.3951 4.3639C11.1021 4.07087 10.7047 3.90625 10.2903 3.90625H4.6875C3.39308 3.90625 2.34375 4.95558 2.34375 6.25V18.75C2.34375 20.0444 3.39308 21.0938 4.6875 21.0938H20.3125C21.6069 21.0938 22.6562 20.0444 22.6562 18.75V9.375C22.6562 8.08058 21.6069 7.03125 20.3125 7.03125H14.7097C14.2953 7.03125 13.8979 6.86663 13.6049 6.5736Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M18 18.5V15.75M19.25 18.5V15.75M16.75 18.5V15.75M15 14.5L18 12.5L21 14.5M20.5 18.5V14.9442C19.6854 14.8164 18.8505 14.75 18 14.75C17.1495 14.75 16.3146 14.8164 15.5 14.9442V18.5M15 18.5H21M18 13.75H18.0025V13.7525H18V13.75Z"
				:stroke="color"
				stroke-width="0.8"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCompanyDirectory',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
